import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483f9d99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-box" }
const _hoisted_2 = { class: "old-price" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "原价", -1))
const _hoisted_4 = { class: "price" }
const _hoisted_5 = {
  key: 1,
  class: "showinfo"
}
const _hoisted_6 = {
  key: 2,
  class: "showinfo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
        (_ctx.data.activity_yh_price && _ctx.data.activity_yh_price > 0) ||
        _ctx.data.vip_yh_price > 0
      )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("i", {
              class: _normalizeClass(["icon iconfont", {
            'icon-a-Group14379': _ctx.orderType == 0,
            'icon-renminbi': _ctx.orderType == 1,
          }])
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(_ctx.showPrice(_ctx.data.goods_price, _ctx.orderType)), 1)
          ]),
          _hoisted_3
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, [
      _createElementVNode("i", {
        class: _normalizeClass(["icon iconfont", {
          'icon-a-Group14379': _ctx.orderType == 0,
          'icon-renminbi': _ctx.orderType == 1,
        }])
      }, null, 2),
      _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.getGoodsPrice(_ctx.data), _ctx.orderType)), 1)
    ]),
    (_ctx.data.activity_yh_price > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "折扣价"))
      : (_ctx.data.vip_yh_price > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "会员价"))
        : _createCommentVNode("", true)
  ]))
}